import React from 'react';

export const StatCard = ({ label, value, variant = 'default' }) => (
  <div className="bg-white border border-slate-200/50 rounded-xl p-5">
    <div className="text-sm text-slate-500 mb-2">{label}</div>
    <div className={`text-3xl font-bold tracking-tight ${variant === 'success' ? 'text-green-600' : 'text-slate-800'}`}>
      {value}
    </div>
  </div>
);
